// cspell: ignore autosync
import { ScrcpyOptions1_18 } from './1_18.js';
import { toScrcpyOptionValue } from "./common.js";
function toSnakeCase(input) {
    return input.replace(/([A-Z])/g, '_$1').toLowerCase();
}
export class ScrcpyOptions1_21 extends ScrcpyOptions1_18 {
    constructor(init) {
        super(init);
    }
    getDefaultValue() {
        return Object.assign(Object.assign({}, super.getDefaultValue()), { clipboardAutosync: true });
    }
    formatServerArguments() {
        // 1.21 changed the format of arguments
        // So `getArgumentOrder()` is no longer needed
        return Object.entries(this.value)
            .map(([key, value]) => [key, toScrcpyOptionValue(value, undefined)])
            .filter((pair) => pair[1] !== undefined)
            .map(([key, value]) => `${toSnakeCase(key)}=${value}`);
    }
}
//# sourceMappingURL=1_21.js.map